import React, { useState } from 'react';
import T from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import LegendApp from '../LegendApp';
import MonthsDropdown from '../../../../_shared/components/MonthsDropdown';
import TransitionsChart from '../../../../_shared/components/TransitionsChart';
import TransitionsTable from '../../../../_shared/components/TransitionsTable';
import Button from '../../../../../../components/Buttons/Button';
import CollapsibleSlot from '../../../../../../components/CollapsibleSlot';
import ErrorStateWithReload from '../../../../../../components/ErrorStateWithReload';
import useTransitionsTableAxes from '../../../hooks/useTransitionsTableAxes';
import { aiCohortsNodes, aiCohortsChurnedNames } from '../../../configs/constants';
import { lastTransitionDate } from '../../../utils';
import { segmentTransitionsSelector } from '../../../selectors';
import { fetchSegmentTransitions } from '../../../actions';

const SegmentTransitions = ({ isPress }) => {
  const dispatch = useDispatch();

  const { settings, data, filters } = useSelector(segmentTransitionsSelector);

  const { tableData, columns, rows } = useTransitionsTableAxes({ data: data.table_data });

  const [isOpen, setOpen] = useState(false);

  const handlePeriodChange = (value) => {
    dispatch(fetchSegmentTransitions({ month_date: value }));
  };

  if (settings.error) return <ErrorStateWithReload className="py-xl" />;

  return (
    <div className="segment-transitions">
      <header className="section-body-header">
        <div className="section-body-header__left">
          <h4 className="section-body-header__title">Segment Transitions</h4>
        </div>
        <div className="section-body-header__right">
          <MonthsDropdown
            selected={filters.month_date}
            latestMonth={lastTransitionDate}
            disabled={settings.pending}
            onChange={handlePeriodChange}
          />
          <div className="separator-v" />
          <Button
            shape="square"
            variant="secondary"
            active={isOpen}
            onClick={() => setOpen((open) => !open)}
          >
            <span className="hicon-list-button" />
          </Button>
        </div>
      </header>
      <TransitionsChart
        settings={settings}
        data={data}
        nodes={aiCohortsNodes}
        exitNodeNames={aiCohortsChurnedNames}
        withEndSeries
        selectedDate={filters.month_date}
        footerRight={<LegendApp />}
        isPress={isPress}
      />
      <CollapsibleSlot show={isOpen} className="toggle-collapsible--slide-in-out">
        <TransitionsTable
          data={tableData}
          rows={rows}
          columns={columns}
          isPending={settings.pending}
        />
      </CollapsibleSlot>
    </div>
  );
};

SegmentTransitions.propTypes = {
  isPress: T.bool,
};

export default SegmentTransitions;
